import { Navigate, Outlet } from 'react-router-dom';
import { FC } from 'react';

interface PrivateRouteProps {
  isAuthenticated: boolean;
  isLoading: boolean;
}
const PrivateRoute: FC<PrivateRouteProps> = (
  {
    isAuthenticated,
    isLoading
  }
) => {

  if (isLoading) {
    return <div>L O A D I N G...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Outlet />
};

export default PrivateRoute;
